import { Editor } from 'slate'
import { useSlate } from 'slate-react'
import React from 'react'

import EditorIcon from '../EditorIcon'

const isActive = (editor, name) => {
  const marks = Editor.marks(editor)
  return marks ? !!marks[name] : false
}

const toggle = (editor, name) => {
  const active = isActive(editor, name)

  if (!active) {
    Editor.addMark(editor, name, true)
  } else {
    Editor.removeMark(editor, name)
  }
}

const ToggleIcon = ({ icon, name, ...props }) => {
  const editor = useSlate()
  const active = isActive(editor, name)

  return <EditorIcon onClick={() => toggle(editor, name)} icon={icon} active={active} {...props} />
}

const MarkerPlugin = {
  isActive,
  toggle,
  ToggleIcon
}

export default MarkerPlugin
